import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration using environment variables (set in .env file)
const firebaseConfig = {
    apiKey: "AIzaSyBbL5-iwIzAeURQSKpAm6eRLBXiQt8-AXE",
    authDomain: "clarity-impact-finance-8134b.firebaseapp.com",
    projectId: "clarity-impact-finance-8134b",
    storageBucket: "clarity-impact-finance-8134b.appspot.com",
    messagingSenderId: "759478531020",
    appId: "1:759478531020:web:8b3997de5c36020c566369",
    measurementId: "G-SW83XR4C88"
};

// Initialize Firebase only if keys exist (prevents build errors on empty env)
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app); 